/* eslint-disable no-undef */
import { Box, CircularProgress, Typography } from "@material-ui/core";
import { useKeycloak } from "@react-keycloak/web";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useTokenParsed } from "store/auth/auth-store";

export const PrefetchingErrorScreen = () => {
  const navigate = useNavigate();
  const { initialized, keycloak } = useKeycloak();
  const { setTokenParsed } = useTokenParsed();
  const { t } = useTranslation("common");

  useEffect(() => {
    if (initialized) {
      console.log("keycloak", keycloak.tokenParsed);
      if (
        keycloak?.authenticated &&
        keycloak?.tokenParsed?.subscriptionAttributes
      ) {
        setTokenParsed(keycloak?.tokenParsed);
        navigate("/app/dashboard", {
          replace: true,
          state: { from: window.location.pathname },
        });
      }
      // else {
      //   navigate("/auth/login", {
      //     replace: true,
      //     state: { from: window.location.pathname },
      //   });
      // }
    }
  }, [initialized, keycloak?.authenticated, navigate]);

  return (
    <Box
      display="flex"
      minWidth="100vw"
      minHeight="100vh"
      justifyContent="center"
      flexDirection="column"
      alignItems="center"
    >
      <h3 translate="yes">{t("user-created-message")}</h3>
    </Box>
  );
};

export const PrefetchingScreen = () => (
  <div
    style={{
      width: "100vw",
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
    }}
  >
    <h1 style={{ marginBottom: 50 }}>Uverify</h1>
    <CircularProgress style={{ marginBottom: 20 }} />
    <Typography>We are loading your data</Typography>
    <Typography>Please wait a moment!</Typography>
  </div>
);

export default PrefetchingErrorScreen;
